import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Ton d'un statut : succès, information, attention, problème ou neutre. */
export type StatusTone = 'success' | 'info' | 'warning' | 'danger' | 'neutral';

const DOT: Record<StatusTone, string> = {
  success: 'bg-[#1F8A4C]',
  info: 'bg-brand',
  warning: 'bg-[#B7791F]',
  danger: 'bg-[#C2410C]',
  neutral: 'bg-[#8792A2]',
};

/**
 * Statut : point coloré + libellé sur fond neutre. Les couleurs vives restent réservées
 * aux produits (couleurs d'univers) ; le libellé porte toujours le sens, pas la couleur seule.
 */
export function StatusDot({ tone = 'neutral', children, className }: { tone?: StatusTone; children: ReactNode; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-[#F1F4F8] px-2.5 py-0.5 text-xs font-medium text-ink', className)}>
      <span className={cn('size-1.5 shrink-0 rounded-full', DOT[tone])} aria-hidden="true" />
      {children}
    </span>
  );
}
